import { Episode } from 'model/Episode'
import { Feature } from 'model/Feature'
import { Series } from 'model/Series'

export const getRadarProductID = <T extends Feature | Episode | Series>(
    obj?: T | null,
): string | null => {
    return obj?.static.productId ?? null
}
